/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * @type AssetLogListItemResponseDtoRawLog
 * Raw message from metadata.rawMessage
 * @export
 */
export type AssetLogListItemResponseDtoRawLog = string | { [key: string]: any; };

export function AssetLogListItemResponseDtoRawLogFromJSON(json: any): AssetLogListItemResponseDtoRawLog {
    return AssetLogListItemResponseDtoRawLogFromJSONTyped(json, false);
}

export function AssetLogListItemResponseDtoRawLogFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetLogListItemResponseDtoRawLog {
    if (json == null) {
        return json;
    }
    if (typeof json === 'string') {
        return json;
    }
    return {} as any;
}

export function AssetLogListItemResponseDtoRawLogToJSON(json: any): any {
    return AssetLogListItemResponseDtoRawLogToJSONTyped(json, false);
}

export function AssetLogListItemResponseDtoRawLogToJSONTyped(value?: AssetLogListItemResponseDtoRawLog | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value === 'string') {
        return value;
    }
    return {};
}

